export default {
    list: []
}
